export default {
    list: []
}
